import { Header, Footer, TariffCards, Serv, Part, Maps } from '../../../components/mainPage';
import React, {useEffect, useState} from 'react'

import translate from './../../Translate/mainPage.json';
import tariffsTr from './../../Translate/tariffs.json';

function MainPage({signStatus, decoders}){  
  const [language, setLanguage] = useState('eng');
  useEffect(() => {
    document.body.style.overflow = 'auto';
    setLanguage(JSON.parse(localStorage.getItem('choosen-language')))
  }, [])

  const getLanguage = (item) => {
    setLanguage(item);
  }

  return (
  <div>
    <Header signStatus={signStatus} getLanguage={getLanguage}/>
    <div className='main'>
      <div className='in'>
       
        <h2 className='main-pages-titles'> {translate.name[language]}</h2>
        <p>{translate.prase1[language]}</p>

        <p>{translate.prase8[language]}</p>
        <p>{translate.prase9[language]}</p>
        <Maps/>
        <h2 className='main-pages-titles'>{translate.prase15[language]}</h2>
        <Part language={language}/>
          
        <h2 className='main-pages-titles'>{tariffsTr.prase1[language]}</h2>
        <TariffCards language={language} decoders={decoders}/>

        <h2 className='main-pages-titles'>{tariffsTr.prase5[language]}</h2>
        <Serv language={language}/>
      </div>
    </div>
    <Footer language={language}/>
  </div>
  );
};

export default MainPage;